import axios, {AxiosResponse} from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const CATALOG_API_URL = process.env.REACT_APP_CATALOG_API_URL;

/**
 * @deprecated v1 do autocomplete (search-engine). Ainda usado pela tela de
 * M-code (finance/MCode); para categoria de item use `getSuggestionByTermV2`.
 */
export const getSuggestionByTerm = async (term: string) => {
  return axios
    .get(`${API_URL}/v1/autocomplete?search_term=${term}`)
    .then(
      (
        d: AxiosResponse<
          {item_id: number; item_code: string; suggestion: string}[]
        >
      ) => d.data
    );
};

export type SearchTermSuggestionV2 = {
  suggestion: string;
  item_name?: string | null;
  suggestion_type: string;
  item_hash?: string | null;
  taxonomy_cest_code?: string | null;
  taxonomy_ncm_code?: string | null;
};

/**
 * v2 do autocomplete do search-engine (`suggestions-search-index`): identifica
 * o item da árvore de categorias pelo `item_hash`.
 */
export const getSuggestionByTermV2 = async (
  term: string
): Promise<SearchTermSuggestionV2[]> => {
  const response = await axios.get<SearchTermSuggestionV2[]>(
    `${API_URL}/v2/autocomplete`,
    {params: {search_term: term}}
  );

  return Array.isArray(response.data) ? response.data : [];
};

export const getAutocompleteSearchOptions = async (
  searchTerm: string
): Promise<
  {
    suggestion: string;
    itemName: string;
    suggestionType: string;
    itemHash: string;
  }[]
> => {
  try {
    const response = await axios.get(
      `${CATALOG_API_URL}/v1/category-tree/autocomplete?searchTerm=${searchTerm}`
    );
    return response.data.data;
  } catch (error) {
    throw new Error(
      `Failed to get autocomplete search options: ${(error as Error).message}`
    );
  }
};
